import React, { Component } from "react";
import EntryForm7 from "../../components/EntryForms/EntryForm7/EntryForm7";
import axiosInstance from "../../api/utils/axiosInstance";
import { connect } from "react-redux";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import {
  handleUserInput,
  handleMappedUserInput,
} from "../../helperFunctions/EntryFormHelperFunctions/userInputHandlers";
import {
  handleCountryAutocomplete,
  countryAutocompleteHandler,
  countyAutocompleteHandler,
  cityAndMuncipalityAutocomplete,
  districtAutocompleteHandler,
} from "../../helperFunctions/EntryFormHelperFunctions/autocompleteHelpers";
import {
  validateRequiredFields,
  validateArrayFields,
} from "../../helperFunctions/validationHelpers/validateRequiredFields";
import { handleDayPicker } from "../../helperFunctions/EntryFormHelperFunctions/datePickerHelper";
import Spinner from "../../components/UI/Spinner/Spinner";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import { toast } from "react-toastify";
import { withRouter } from "react-router";
import { purgeUpdateAndRedirect } from "../../helperFunctions/purgeUpdateAndRedirect";
import { PURGE_UPDATE } from "../../constants/constants";

class RegSubjZaObavljanjeRevUTrecojZemlji extends Component {
  state = {
    error: false,
    requestsLoaded: false,
    showUpdateModal: false,
    loader: false,
    update: false,
    countryList: [],
    countyList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    networksList: [],
    legalForms: [],
    networkMemberInfo: {
      isDrustvoMreza: false,
      idMreze: "",
    },
    newFormData: {
      oznDokumenta: {
        oznDokumenta: "",
      },
      userData: {
        vrDrustva: "",
        oib: "",
        oznAkt: "",
        ime: "",
        prezime: "",
        nazDrustva: "",
        idBroj: "",
        regBroj: "",
        sifPOblika: "",
        opisPOblika: "",
        oibValidated: false,
        requiredFieldsUserData: ["vrDrustva", "sifPOblika", "nazDrustva"],
        tstampUnosa: null,
      },

      address: {
        vrAdr: "1",
        sifDrzave: "191",
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        permitNumber: "",
        permitDate: "",
        requiredFieldsAddress: [
          "sifDrzave",
          "sifZupanije",
          "nazZupanije",
          "sifGrdOpc",
          "nazGrdOpc",
          "sifNaselja",
          "nazNaselja",
          "ulicaKbr",
          "permitDate",
          "permitNumber",
        ],
      },

      createNewNetworkModal: false,
      createNewNetworkData: {
        nazMreze: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        web: "",
        requiredFieldsCreateNewNetwork: [
          "nazMreze",
          "sifDrzave",
          "nazNaselja",
          "brPoste",
          "ulicaKbr",
        ],
      },
      networkUpdateObj: {
        nazMreze: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        requiredFieldsNetworkUpdate: [
          "nazMreze",
          "nazNaselja",
          "brPoste",
          "ulicaKbr",
        ],
      },
      contactInformation: {
        ime: "",
        prezime: "",
        telefon: "",
        web: "",
        email: "",
        emailValidated: false,
      },
      basicReviserData: [
        {
          oib: "",
          prezime: "",
          ime: "",
          regBroj: "",
          idOsobe: "",
          id: 1,
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: false,
        },
      ],
      auditCompanyMember: [
        {
          vrClana: "1",
          oib: "",
          ime: "",
          prezime: "",
          naziv: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: 1,
          oibValidated: false,
          requiredFieldsAuditCompanyMember: [
            // "ime",
            // "prezime",
            // "naziv",
            "sifDrzave",
          ],
        },
      ],
      auditCompanyBoardMember: [
        {
          vrClana: "2",
          oib: "",
          ime: "",
          prezime: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          funkcija: "",
          ulicaKbr: "",
          brRegOrig: "",
          id: 1,
          oibValidated: false,
          requiredFieldsAuditCompanyBoardMember: [
            "ime",
            "prezime",
            "funkcija",
            "sifDrzave",
          ],
        },
      ],
      auditCompanyRegistration: [
        {
          id: 1,
          vrRegistracije: "3",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          // requiredFieldsAuditCompanyRegistration: ["ulicaKbr"],
        },
      ],
      memberInfo: [
        {
          vrClana: "",
          // memberType: "",
          id: 1,
          idMreze: "",
          nazDrustva: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          // requiredFieldsMemberInfo: ["vrClana"]
        },
      ],
      dropDownData: [
        { id: 3, value: "Direktor"},
        { id: 4, value: "Predsjednik uprave" },
        { id: 5, value: "Član uprave" },
        { id: 6, value: "Prokurist" },
        { id: 7, value: "Član upravnog odbora" },
      ],
      mjere: [],
    },
  };

  componentDidMount = () => {
    this.getCountryList();
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCountyList();
      }
    );
  };

  getCountyList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/zupanije");
    this.setState(
      {
        countyList: data,
      },
      () => {
        this.getNetworks();
      }
    );
  };

  getCityAndMuncipalityList = async (countyId) => {
    const { data } = await axiosInstance.get(
      `/sifarnici/gradOpcina/${countyId}`
    );
    this.setState(
      {
        cityAndMuncipalityList: data,
      },
      () => { }
    );
  };

  getDistrictList = async (id) => {
    const { data } = await axiosInstance.get(`/sifarnici/naselja/${id}`);
    this.setState({ districtList: data }, () => { });
  };

  getNetworks = async () => {
    try {
      const { data } = await axiosInstance.get("/sifarnici/mreze");
      const networksList = data;

      this.setState(
        {
          networksList,
        },
        () => {
          this.getLegalForms();
        }
      );
    } catch (e) {
      throw e;
    }
  };

  checkIfUpdate = (url) => {
    return this.props.match.url.includes(url);
  };

  getLegalForms = async () => {
    const { data } = await axiosInstance.get("/sifarnici/pravniOblici");
    const legalForms = data;

    this.setState(
      {
        legalForms,
      },
      () => {
        if (
          this.checkIfUpdate(
            "/azuriraj/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji"
          )
        ) {
          if (this.props.idDrustva != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }

          this.getDrustvoEdit();
        } else if (
          this.checkIfUpdate(
            "/azuriraj-po-zahtjevu/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji"
          )
        ) {
          if (this.props.idDrustva != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          const oznDokumenta = this.props.oznDokumenta;
          this.getDrustvoEdit(oznDokumenta);
        } else {
          this.getDataFromUnosZahtjeva();
        }
      }
    );
  };

  getDrustvoEdit = async (oznaka) => {
    const { idDrustva, vrDrustva } = this.props;
    const data = this.props.azuriranjeSubjekata;
    const findAddress = data[2];

    // .find(element => element.vrAdr === 1);

    if (findAddress.sifZupanije) {
      this.getCityAndMuncipalityList(findAddress.sifZupanije);
    }

    if (findAddress.sifGrdOpc) {
      this.getDistrictList(findAddress.sifGrdOpc);
    }

    const findAddressRegistration = data[3].find(
      (element) => element.vrRegistracije === 1
    );



    const address = {
      vrAdr: "1",
      sifDrzave: String(findAddress.sifDrzave),
      sifZupanije: String(findAddress.sifZupanije) || "",
      nazZupanije: findAddress.nazZupanije || "",
      sifGrdOpc: String(findAddress.sifGrdOpc) || "",
      nazGrdOpc: findAddress.nazGrdOpc || "",
      sifNaselja: String(findAddress.sifNaselja),
      nazNaselja: findAddress.nazNaselja,
      brPoste: findAddress.brPoste || "",
      ulicaKbr: findAddress.ulicaKbr || "",
      permitDate: findAddressRegistration.datReg || "",
      permitNumber: findAddressRegistration.brReg || "",
      requiredFieldsAddress: [
        "sifDrzave",
        "sifZupanije",
        "nazZupanije",
        "sifGrdOpc",
        "nazGrdOpc",
        "sifNaselja",
        "nazNaselja",
        "ulicaKbr",
        "permitDate",
        "permitNumber",
      ],
    };

    const findCompanyReg = data[3].filter(
      (element) => element.vrRegistracije === 3
    );

    let auditCompanyRegistration;
    if (findCompanyReg.length > 0) {
      auditCompanyRegistration = findCompanyReg.map((element, index) => {
        return {
          vrRegistracije: "3",
          nazTijela: element.nazTijela || "",
          sifDrzave: String(element.sifDrzave) || "",
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          brReg: element.brReg || "",
          datReg: element.datReg || "",
          id: index + 1,
        };
      });
    } else {
      auditCompanyRegistration =
        this.state.newFormData.auditCompanyRegistration;
    }

    const contactInfo = data[4];

    const contactInformation = {
      ime: contactInfo.ime || "",
      prezime: contactInfo.prezime || "",
      telefon: contactInfo.telefon || "",
      web: contactInfo.web || "",
      email: contactInfo.email || "",
      emailValidated: true,
    };

    const revData = data[5];
    let basicReviserData;

    if (revData.length > 0) {
      basicReviserData = revData.map((element, index) => {
        return {
          oib: element.oibIdBrojOsobe || "",
          prezime: element.prezimeOsobe || "",
          ime: element.imeOsobe || "",
          regBroj: element.regBrojOsobe || "",
          idOsobe: element.idOsobe || "",
          id: index + 1,
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: true,
        };
      });
    } else {
      basicReviserData = this.state.newFormData.basicReviserData;
    }

    const auditCompanyMember = data[6]
      .filter((element) => element.vrClana == 1)
      .map((element, index) => {
        return {
          vrClana: "1",
          oib: element.oib || "",
          ime: element.ime || "",
          prezime: element.prezime || "",
          naziv: element.naziv || "",
          sifDrzave: String(element.sifDrzave),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          id: index + 1,
          oibValidated: true,
          requiredFieldsAuditCompanyMember: [
            // "ime",
            // "prezime",
            // "naziv",
            "sifDrzave",
          ],
        };
      });

    const auditCompanyBoardMember = data[6]
      .filter((element) => element.vrClana == 2)
      .map((element, index) => {
        return {
          vrClana: "2",
          oib: element.oib || "",
          ime: element.ime || "",
          prezime: element.prezime || " ",
          funkcija: element.funkcija || "",
          sifDrzave: String(element.sifDrzave || ""),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          brRegOrig: element.brRegOrig || "",
          id: index + 1,
          oibValidated: true,
          requiredFieldsAuditCompanyBoardMember: [
            "ime",
            "prezime",
            "funkcija",
            "sifDrzave",
          ],
        };
      });

    let networkMemberInfo;
    const isDrustvoMreza = data[7].isDrustvoMreza;
    if (!isDrustvoMreza) {
      networkMemberInfo = {
        isDrustvoMreza: "0",
        idMreze: "",
      };
    } else {
      networkMemberInfo = {
        isDrustvoMreza: "1",
        idMreze: data[7].idMreze,
      };
    }

    let memberInfo;

    if (data[8].length > 0) {
      memberInfo = data[8].map((element, index) => {
        return {
          vrClana: String(element.vrClana),
          // memberType: "",
          id: index + 1,
          idMreze: element.idMreze,
          nazDrustva: element.nazDrustva || "",
          sifDrzave: String(element.sifDrzave) || "",
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          web: element.web || "",
        };
      });
    } else {
      memberInfo = this.state.newFormData.memberInfo;
    }

    let ime;
    let prezime;
    let nazDrustva;
    let vrstaDrustva;
    if (data[1].ime && data[1].prezime) {
      ime = data[1].ime;
      prezime = data[1].prezime;
      nazDrustva = "";
      vrstaDrustva = "2";
    } else if (data[1].nazDrustva) {
      ime = "";
      prezime = "";
      nazDrustva = data[1].nazDrustva;
      vrstaDrustva = "1";
    }

    let oznDokumenta = {};

    if (oznaka) {
      oznDokumenta.oznDokumenta = oznaka;
    } else {
      oznDokumenta.oznDokumenta = data[9].oznDokumenta;
    }

    this.setState((prevState) => ({
      update: true,
      requestsLoaded: true,
      networkMemberInfo,
      newFormData: {
        ...prevState.newFormData,
        oznDokumenta,
        userData: {
          ...prevState.newFormData.userData,
          oznAkt: data[1]?.oznAkt || "",
          idDrustva: data[1]?.idDrustva || "",
          vrDrustva: vrstaDrustva,
          oib: data[1]?.oib || "",
          idBroj: data[1]?.idBroj || "",
          ime: ime,
          prezime: prezime,
          nazDrustva: nazDrustva,
          oibValidated: true,
          sifPOblika: String(data[1]?.sifPOblika || ""),
          opisPOblika: data[1]?.opisPOblika || "",
          regBroj: data[1]?.regBroj || "",
          tstampUnosa: data[1].tstampUnosa,
        },
        address,
        auditCompanyRegistration,
        contactInformation,
        basicReviserData,
        auditCompanyMember,
        auditCompanyBoardMember,
        memberInfo,
        mjere: data[10],
      },
    }));
  };

  getDataFromUnosZahtjeva = async () => {
    const { data } = await fetchFormsApi(
      `/request/${this.props.zahtjevAtrId}?isEdit=${false}`
    );

    const findObjectByLabelAndGroup = (label, group) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find(
          (element) =>
            element.controlLabel == label && element.addressGroup === group
        )
      );
      return findLabel;
    };

    const findObjectByLabel = (label) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find((element) => element.controlLabel == label)
      );
      return findLabel;
    };

    const findCountry = findObjectByLabelAndGroup("Naziv države", 1);
    const findCity = findObjectByLabelAndGroup("Naziv grada", 1);
    const findDistrict = findObjectByLabelAndGroup("Naziv mjesta", 1);
    const findbrPoste = findObjectByLabelAndGroup("Poštanski broj", 1);
    const findUlica = findObjectByLabelAndGroup("Ulica", 1);
    const findKucniBr = findObjectByLabelAndGroup("Kućni broj", 1);
    let ulicaKbr;

    if (findUlica[0].value || findKucniBr[0].value) {
      ulicaKbr = `${findUlica[0].value} ${findKucniBr[0].value}`;
    } else {
      ulicaKbr = "";
    }
    const brPoste = findbrPoste[0].value;

    const findIme = findObjectByLabel("Ime glavne osobe za kontakt");
    const findPrezime = findObjectByLabel("Prezime glavne osobe za kontakt");
    const findTelefon = findObjectByLabel("Telefon/fax");
    const findEmail = findObjectByLabel("E-mail ");
    const findWeb = findObjectByLabel("Adresa internetske stranice");

    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValidated = regexp.test(findEmail[0].value);

    const findRegCountry = findObjectByLabelAndGroup("Naziv države", 2);
    const findRegDistrict = findObjectByLabelAndGroup("Naziv mjesta", 2);
    const findRegbrPoste = findObjectByLabelAndGroup("Poštanski broj", 2);
    const findRegUlicaKbr = findObjectByLabelAndGroup("Ulica i kućni broj", 2);
    const RegBrPoste = findRegbrPoste[0].value;
    const findNazTijela = findObjectByLabel(
      "Naziv nadležnog tijela za izdavanje odobrenja za rad iz treće zemlje"
    );

    const findSifPOblika = findObjectByLabel("Pravni oblik");
    let sifPOblika;
    if (findSifPOblika[0].value != "") {
      const res = await axiosInstance.get(
        `sifarnici/pravniOblici/sifra?nazivPravnogOblika=${findSifPOblika[0].value}`
      );
      if (res.data && res.data.sifPravnogOblika) {
        sifPOblika = res.data.sifPravnogOblika;
      } else {
        sifPOblika = "";
      }
    } else {
      sifPOblika = "";
    }

    let regDistrict;

    if (findRegCountry[0].value == 191 && findRegDistrict[0].value != "") {
      const { data } = await axiosInstance.get(
        `/sifarnici/naselja/naziv/${findRegDistrict[0].value}`
      );
      regDistrict = data.nazNaselja;
    } else {
      regDistrict = findRegDistrict[0].value;
    }

    const auditCompanyRegistration = [
      {
        ...this.state.newFormData.auditCompanyRegistration,
        sifDrzave: findRegCountry[0].value || "",
        nazTijela: findNazTijela[0].value || "",
        nazNaselja: regDistrict || "",
        brPoste: RegBrPoste || "",
        ulicaKbr: findRegUlicaKbr[0].value || "",
        id: 1,
      },
    ];

    const contactInformation = {
      ...this.state.newFormData.contactInformation,
      ime: findIme[0].value || "",
      prezime: findPrezime[0].value || "",
      telefon: findTelefon[0].value || "",
      web: findWeb[0].value || "",
      email: findEmail[0].value || "",
      emailValidated,
    };

    let sifZupanije;
    let nazZupanije;
    let sifGrdOpc;
    let nazGrdOpc;
    let cityAndMuncipalityList;
    let districtList;
    let nazNaselja;
    let sifNaselja;
    let getDistrictList;

    if (findCountry[0].value == 191 && findCity[0].value != "") {
      const response = await axiosInstance.get(
        `/sifarnici/grad/${findCity[0].value}`
      );
      sifZupanije = response.data.sifZupanije.toString();
      nazZupanije = response.data.nazZupanije;
      sifGrdOpc = findCity[0].value;

      const getCityList = await axiosInstance.get(
        `/sifarnici/gradOpcina/${sifZupanije}`
      );
      cityAndMuncipalityList = getCityList.data;

      getDistrictList = await axiosInstance.get(
        `/sifarnici/naselja/${sifGrdOpc}`
      );
      districtList = getDistrictList.data;
      const findNazivGrada = getCityList.data.filter((element) =>
        element.gradoviOpcine.find((el) => el.sifGrdOpc == sifGrdOpc)
      );

      nazGrdOpc = findNazivGrada[0].gradoviOpcine[0].nazGrdOpc;

      sifNaselja = findDistrict[0].value;

      const findNazivNaselja = getDistrictList.data.filter((element) =>
        element.naselja.find((el) => el.sifNaselja == sifNaselja)
      );

      if (findNazivNaselja.length > 0) {
        nazNaselja = findNazivNaselja[0].naselja[0].nazNaselja;
      } else {
        nazNaselja = findDistrict[0].value;
        sifNaselja = "";
      }
    } else {
      nazZupanije = "";
      sifZupanije = "";
      nazGrdOpc = findCity[0].value;
      cityAndMuncipalityList = [];
      districtList = [];
      nazNaselja = findDistrict[0].value;
      sifGrdOpc = "";
      sifNaselja = "";
      districtList = [];
    }

    const address = {
      ...this.state.newFormData.address,
      sifDrzave: findCountry[0].value,
      sifZupanije,
      nazZupanije,
      sifGrdOpc,
      nazGrdOpc,
      brPoste,
      ulicaKbr,
      nazNaselja,
      sifNaselja,
    };

    this.setState((prevState) => ({
      cityAndMuncipalityList,
      districtList,
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          sifPOblika,
        },
        address,
        contactInformation,
        auditCompanyRegistration,
      },
    }));

    this.disableLoader();
  };

  disableLoader = () => {
    this.setState({
      requestsLoaded: true,
    });
  };

  multiplyComponent = (e, objData) => {
    e.persist();

    const lastElem = [...this.state.newFormData[objData.formGroup]];
    let addNewElement;

    switch (objData.formGroup) {
      case "basicReviserData":
        addNewElement = {
          oib: "",
          prezime: "",
          ime: "",
          regBroj: "",
          idOsobe: "",
          id: lastElem[lastElem.length - 1].id + 1,
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: false,
        };
        break;
      case "auditCompanyMember":
        addNewElement = {
          vrClana: "1",
          oib: "",
          ime: "",
          prezime: "",
          naziv: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: lastElem[lastElem.length - 1].id + 1,
          oibValidated: false,
          requiredFieldsAuditCompanyMember: [
            // "ime",
            // "prezime",
            // "naziv",
            "sifDrzave",
          ],
        };
        break;
      case "auditCompanyBoardMember":
        addNewElement = {
          vrClana: "2",
          oib: "",
          ime: "",
          prezime: "",
          sifDrzave: "191",
          nazNaselja: "",
          funkcija: "",
          brPoste: "",
          ulicaKbr: "",
          brRegOrig: "",
          id: lastElem[lastElem.length - 1].id + 1,
          oibValidated: false,
          requiredFieldsAuditCompanyBoardMember: [
            "ime",
            "prezime",
            "funkcija",
            "sifDrzave",
          ],
        };
        break;
      case "memberInfo":
        addNewElement = {
          vrClana: "",
          // memberType: "",
          id: lastElem[lastElem.length - 1].id + 1,
          idMreze: "",
          nazDrustva: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          // requiredFieldsMemberInfo: ["vrClana"]
        };

        break;
      case "auditCompanyRegistration":
        addNewElement = {
          id: lastElem[lastElem.length - 1].id + 1,
          vrRegistracije: "3",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
        };
        break;
      default:
        break;
    }
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.formGroup]: [
          ...prevState.newFormData[objData.formGroup],
          addNewElement,
        ],
      },
    }));
  };

  openNetworkUpdateModal = () => {
    const { networkMemberInfo } = this.state;

    const findNetworkObjById = this.state.networksList.find(
      (element) => element.idMreze == networkMemberInfo.idMreze
    );

    this.setState((prevState) => ({
      showUpdateModal: true,
      newFormData: {
        ...prevState.newFormData,
        networkUpdateObj: {
          ...findNetworkObjById,
          requiredFieldsNetworkUpdate: [
            "nazMreze",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  hideUpdateModal = () => {
    this.setState((prevState) => ({
      showUpdateModal: false,
      newFormData: {
        ...prevState.newFormData,
        networkUpdateObj: {
          nazMreze: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          requiredFieldsNetworkUpdate: [
            "nazMreze",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  updateNetworkHandler = async () => {
    const stateCopy = { ...this.state.newFormData };

    const { requiredFieldsNetworkUpdate } = stateCopy.networkUpdateObj;

    const validateNetworkSubmit = validateRequiredFields(
      stateCopy.networkUpdateObj,
      requiredFieldsNetworkUpdate
    );

    if (!validateNetworkSubmit) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    this.setState({ loader: true }, async () => {
      try {
        let submitData = { ...stateCopy.networkUpdateObj };
        delete submitData.requiredFieldsNetworkUpdate;
        const res = await axiosInstance.patch(
          `/sifarnici/mreza/edit/${stateCopy.networkUpdateObj.idMreze}`,
          submitData
        );
        this.setState(
          (prevState) => ({
            loader: false,
            showUpdateModal: false,
          }),
          async () => {
            this.props.formSubmitSuccess(false, "Mreža je uspješno ažurirana!");
            const { data } = await axiosInstance.get("/sifarnici/mreze");
            const networksList = data;

            this.setState({
              networksList,
              networkMemberInfo: {
                isDrustvoMreza: true,
                idMreze: "",
              },
            });
          }
        );
      } catch (e) {
        throw e;
        this.props.formSubmitSuccess(
          true,
          "Nešto je pošlo po krivu s ažuriranjem mreže!"
        );
        this.setState({
          loader: false,
        });
      }
    });
  };

  getReviserDataByOib = async (e) => {
    e.persist();
    const id = e.currentTarget.id;
    const stateCopy = { ...this.state.newFormData };
    const findReviserObject = stateCopy.basicReviserData.find(
      (element) => element.id == id
    );

    try {
      const { data } = await axiosInstance.get(
        `/sifarnici/osobe?oib=${findReviserObject.oib}`
      );

      if (data.length === 0) {
        this.props.formSubmitError(
          true,
          "Za OIB/identifikator koji ste unijeli nema dostupnih podataka o ovlaštenom revizoru! Unesite ispravan OIB/identifikator."
        );
        return;
      }

      //ovo je hardkodirano, potrebno vidjeti s bekendom u vezi ovoga
      let reviserObject = { ...findReviserObject };
      reviserObject.ime = data[0].ime;
      reviserObject.prezime = data[0].prezime;
      reviserObject.regBroj = data[0].regBroj;
      reviserObject.idOsobe = String(data[0].idOsobe);

      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          basicReviserData: [
            ...prevState.newFormData.basicReviserData.map((element) => {
              return element.id == id ? reviserObject : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  mappedUserInputHandler = (e, objectData) => {
    e.persist();
    this.setState(handleMappedUserInput(e, objectData));
  };

  funkcijaDropDownHandler = (e) => {
    e.persist()
    const id = e.target.id.replace(/[^0-9]/g, ""); 
    let funk;
      switch (Number(e.target.value)) {
        case 3:
          funk= "Direktor";
          break;
        case 4: 
          funk= "Predsjednik uprave";
          break;
        case 5:
          funk="Član uprave";
          break;
        case 6:
          funk="Prokurist";
          break;
        case 7:
          funk="Član upravnog odbora";
          break;
        default:
          break;
      }
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        auditCompanyBoardMember: [
          ...prevState.newFormData.auditCompanyBoardMember.map((element) => {
            return element.id == id
              ? {
                ...element,
                funkcija: funk,
              }
              : element;
          }),
        ],
      },
    }));
  }

  setCountryAutocompleteHandler = (values, objectData) => {
    this.setState(handleCountryAutocomplete(values, objectData));
  };

  autocompleteCountryHandler = (values, objectData) => {
    this.setState(countryAutocompleteHandler(values, objectData));
  };

  autocompleteCountyHandler = (values, objectData) => {
    this.setState(
      countyAutocompleteHandler(
        values,
        objectData,
        this.getCityAndMuncipalityList
      )
    );
  };

  autocompleteCityHandler = (values, objectData) => {
    this.setState(
      cityAndMuncipalityAutocomplete(values, objectData, this.getDistrictList)
    );
  };

  autocompleteDistrictHandler = (values, objectData) => {
    const stateCopy = this.state;

    this.setState(districtAutocompleteHandler(values, objectData), () => {
      if (
        stateCopy.newFormData[objectData.formGroup].hasOwnProperty("brPoste") &&
        values != null
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.formGroup]: {
              ...prevState.newFormData[objectData.formGroup],
              brPoste: String(values.brPoste),
            },
          },
        }));
      }
    });
  };
  userInputHandler = (e, objectData) => {
    e.persist();
    // const id = e.target.id.replace(/[0-9]/g, "");
    const { name } = e.target;
    const isEmail = name === "email";

    this.setState(handleUserInput(e, objectData), () => {
      isEmail && this.validateEmail(e, objectData);
      name === "oib" &&
        this.state.newFormData.userData.oibValidated &&
        this.fetchUserDataCoib();
    });
  };

  fetchUserDataCoib = async () => {
    if (this.state.newFormData.userData.vrDrustva == "") {
      toast.info("Odaberite vrstu revizora!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    const oib = this.state.newFormData.userData.oib;
    const { data } = await axiosInstance.get(`/sifarnici/oib-data/${oib}`);

    const sifGradOpcina = data.sifraGradaOpcine.replace(/^0+/, "");
    const sifraNaselja = data.sifraNaselja.replace(/^0+/, "");

    let userData;

    if (this.state.newFormData.userData.vrDrustva == "1") {
      userData = {
        ...this.state.newFormData.userData,
        nazDrustva: data.nazivSkraceni || "",
        prezime: "",
        ime: "",
      };
    } else if (this.state.newFormData.userData.vrDrustva == "2") {
      userData = {
        ...this.state.newFormData.userData,
        nazDrustva: "",
        prezime: data.prezime || "",
        ime: data.ime || "",
      };
    }

    this.getCityAndMuncipalityList(data.sifraZupanije);
    this.getDistrictList(sifGradOpcina);

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData,
        address: {
          ...prevState.newFormData.address,
          sifDrzave: data.sifraDrzave,
          sifZupanije: data.sifraZupanije,
          nazZupanije: data.nazivZupanije,
          sifGrdOpc: sifGradOpcina,
          nazGrdOpc: data.grad,
          sifNaselja: sifraNaselja,
          nazNaselja: data.naselje,
          brPoste: data.postanskiBroj,
          ulicaKbr: `${data.adresa} ${data.kucniBroj} ${data.kucniBrojDodatak}`,
        },
      },
    }));
  };

  validateEmail = (e, objectData) => {
    const value = e.target.value;
    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValidated = regexp.test(value);
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        contactInformation: {
          ...prevState.newFormData.contactInformation,
          emailValidated,
        },
      },
    }));
  };

  //MREŽE

  createNewNetworkModal = () => {
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        createNewNetworkModal: !prevState.newFormData.createNewNetworkModal,
        createNewNetworkData: {
          nazMreze: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          web: "",
          ulicaKbr: "",
          requiredFieldsCreateNewNetwork: [
            "nazMreze",
            "sifDrzave",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  networkDropdownHandler = (e) => {
    e.persist();
    const isDrustvoMreza = e.target.value;
    this.setState((prevState) => ({
      networkMemberInfo: {
        ...prevState.networkMemberInfo,
        isDrustvoMreza,
      },
    }));
  };

  revisorDropdownHandler = (e) => {
    e.persist();
    const userData = { ...this.state.newFormData.userData };
    //resetiraj vrijednosti ako se vrijednost dropdowna promijeni
    userData.vrDrustva = e.target.value;
    userData.oib = "";
    userData.idBroj = "";
    userData.oibValidated = false;
    userData.ime = "";
    userData.prezime = "";
    userData.nazDrustva = "";
    userData.oibValidated = false;
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData,
      },
    }));
  };

  vrClanaDropdownHandler = (selectedValue, id) => {
    if (selectedValue == null) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          memberInfo: [
            ...prevState.newFormData.memberInfo.map((element) =>
              element.id == id
                ? {
                  vrClana: "",
                  id: element.id,
                  idMreze: "",
                  idDrustva: "",
                  nazDrustva: "",
                  sifDrzave: "191",
                  nazNaselja: "",
                  brPoste: "",
                  ulicaKbr: "",
                  web: "",
                }
                : element
            ),
          ],
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        memberInfo: [
          ...prevState.newFormData.memberInfo.map((element) =>
            element.id == id
              ? {
                vrClana: selectedValue.id,
                id: element.id,
                idMreze: "",
                idDrustva: "",
                nazDrustva: "",
                sifDrzave: "191",
                nazNaselja: "",
                brPoste: "",
                ulicaKbr: "",
                web: "",
              }
              : element
          ),
        ],
      },
    }));
  };

  setSelectedNetworkDropdown = async (e) => {
    const idMreze = e.target.value;
    this.setState((prevState) => ({
      networkMemberInfo: {
        ...prevState.networkMemberInfo,
        idMreze,
      },
    }));
  };

  setSelectedNetworkToArray = async (e) => {
    e.persist();
    const idMreze = e.target.value;
    const id = e.target.id.replace(/[^0-9]/g, "");

    let findObject = {
      ...this.state.newFormData.memberInfo.find((element) => element.id == id),
    };

    findObject.idMreze = e.target.value;
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        memberInfo: [
          ...prevState.newFormData.memberInfo.map((element) => {
            return element.id == id ? findObject : element;
          }),
        ],
      },
    }));
  };

  removeComponentHandler = (e, objectData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objectData.formGroup]];
    const { formGroup } = objectData;
    const arrayLength = this.state.newFormData[formGroup].length;
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    if (arrayLength > 1) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          [formGroup]: [
            ...prevState.newFormData[formGroup].filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
    } else {
      alert("Uklanjanje nije moguće!");
    }
  };

  createNewNetworkSubmitHandler = async () => {
    const stateCopy = { ...this.state.newFormData };

    const { requiredFieldsCreateNewNetwork } = stateCopy.createNewNetworkData;

    const validateNetworkSubmit = validateRequiredFields(
      stateCopy.createNewNetworkData,
      requiredFieldsCreateNewNetwork
    );

    if (!validateNetworkSubmit) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    this.setState({ loader: true }, async () => {
      try {
        let submitData = { ...stateCopy.createNewNetworkData };
        delete submitData.requiredFieldsCreateNewNetwork;
        const res = await axiosInstance.post("/sifarnici/mreza", submitData);

        this.setState(
          (prevState) => ({
            loader: false,
            newFormData: {
              ...prevState.newFormData,
              createNewNetworkModal: false,
            },
          }),
          async () => {
            this.props.formSubmitSuccess(
              false,
              "Nova mreža je uspješno kreirana!"
            );
            const { data } = await axiosInstance.get("/sifarnici/mreze");
            const networksList = data;

            this.setState({
              networksList,
            });
          }
        );
      } catch (e) {
        this.props.formSubmitSuccess(
          true,
          "Nešto je pošlo po krivu s kreiranjem mreže!"
        );
        this.setState({
          loader: false,
        });
      }
    });
  };

  handleDayClick = (date, dateString, objData) => {
    this.setState(handleDayPicker(dateString, objData));
  };

  dropdownHandler = (e) => {
    e.persist();
    const sifPOblika = e.target.value;
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          sifPOblika,
          opisPOblika: "",
        },
      },
    }));
  };

  submitHandler = async (e) => {
    e.preventDefault();

    const stateCopy = { ...this.state.newFormData };
    let { requiredFieldsUserData } = stateCopy.userData;

    if (stateCopy.userData.vrDrustva == 2) {
      requiredFieldsUserData = ["prezime", "ime", "vrDrustva", "sifPOblika"];
    }
    const validateUserData = validateRequiredFields(
      stateCopy.userData,
      requiredFieldsUserData
    );

    let { requiredFieldsAddress } = stateCopy.address;
    if (stateCopy.address.sifDrzave != "191") {
      requiredFieldsAddress = [
        "sifDrzave",
        "nazNaselja",
        "ulicaKbr",
        "permitDate",
        "permitNumber",
      ];
    }
    const validateAddress = validateRequiredFields(
      stateCopy.address,
      requiredFieldsAddress
    );

    const validateBasicReviserData = validateArrayFields(
      stateCopy.basicReviserData,
      "requiredFieldsRevData"
    ).every((element) => element === true);

    const validateAuditCompanyMember = validateArrayFields(
      stateCopy.auditCompanyMember,
      "requiredFieldsAuditCompanyMember"
    ).every((element) => element === true);

    const validateAuditCompanyBoardMember = validateArrayFields(
      stateCopy.auditCompanyBoardMember,
      "requiredFieldsAuditCompanyBoardMember"
    ).every((element) => element === true);

    if (
      !validateUserData ||
      !validateAddress ||
      !validateBasicReviserData ||
      !validateAuditCompanyMember ||
      !validateAuditCompanyBoardMember
      // ||
      // // ||
      // // !validateMemberInfo
      // !validateAuditCompReg
    ) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    if (
      stateCopy.userData.oib.length < 1 &&
      stateCopy.userData.idBroj.length < 1
    ) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Unesite OIB ili identifikator!");
        }
      );
      return;
    }

    if (
      stateCopy.userData.sifPOblika == "999" &&
      stateCopy.userData.opisPOblika.length < 1
    ) {
      return this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Unesite opis pravnog oblika!");
        }
      );
    }

    if (!stateCopy.userData.oibValidated && stateCopy.userData.oib.length > 0) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Osnovni podaci)"
      );
      return;
    }

    const validateAuditCompanyMemberOib = [...stateCopy.auditCompanyMember]
      .filter((element) => element.oib.length > 0)
      .every((element) => element.oibValidated === true);

    if (!validateAuditCompanyMemberOib) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Član/dioničar revizorskog društva)"
      );
      return;
    }

    const validateAuditCompanyBoardMemberOib = [
      ...stateCopy.auditCompanyBoardMember,
    ]
      .filter((element) => element.oib.length > 0)
      .every((element) => element.oibValidated === true);

    if (!validateAuditCompanyBoardMemberOib) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Član uprave ili upravnog odbora revizorskog društva)"
      );
      return;
    }

    const networkNotSelected = [...stateCopy.memberInfo]
      .filter((element) => element.vrClana === "1")
      .every((element) => element.idMreze);

    if (!networkNotSelected) {
      this.props.formSubmitError(true, "Odaberite pripadnost mreži!");
      return;
    }

    //ako je korisnik odabrao pripadnost mrezi/drustvu, provjeri jesu li svi fieldovi popunjeni (adresa ili web)
    const networkAddressNotFilled = [...stateCopy.memberInfo]
      .filter((element) => element.vrClana != "")
      .every(
        (element) =>
          (element.nazNaselja &&
            element.brPoste &&
            element.ulicaKbr &&
            element.brPoste) ||
          element.web
      );

    //ovo treba dobro testirati, upozoriti testere!
    if (!networkAddressNotFilled) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(
            true,
            "Popunite adresu ili web adresu za provjeru podataka!"
          );
        }
      );
      return;
    }

    const isEmailValidated = stateCopy.contactInformation.emailValidated;

    if (!isEmailValidated && stateCopy.contactInformation.email.length > 0) {
      this.setState({ error: true }, () => {
        this.props.formSubmitError(
          true,
          "E-mail koji ste upisali nije ispravan! (Osoba za kontakt)"
        );
      });

      return;
    }

    let userData = { ...stateCopy.userData };
    userData.vrDrustva = "4";
    delete userData.oibValidated;
    delete userData.requiredFieldsUserData;
    delete userData.oznAkt;

    if (userData.vrDrustva == 1) {
      delete userData.ime;
      delete userData.prezime;
    }

    if (userData.vrDrustva == 2) {
      delete userData.nazDrustva;
    }
    const address = { ...stateCopy.address };

    const regAddress = {
      vrRegistracije: "1",
      sifDrzave: address.sifDrzave,
      brReg: address.permitNumber,
      datReg: address.permitDate,
    };

    delete address.permitDate;
    delete address.permitNumber;
    delete address.requiredFieldsAddress;

    const auditCompanyRegistration = [
      ...stateCopy.auditCompanyRegistration,
    ].map((element) => {
      return {
        vrRegistracije: "3",
        nazTijela: element.nazTijela,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
        brReg: element.brReg,
        datReg: element.datReg,
      };
    });
    //podaci o korisniku
    // delete auditCompanyRegistration.requiredFieldsAuditCompanyRegistration;

    const contactInformation = { ...stateCopy.contactInformation };
    delete contactInformation.requiredFieldsContactInfo;
    delete contactInformation.id;
    delete contactInformation.emailValidated;

    //veza => ovlašteni revizor

    const basicReviserData = [...stateCopy.basicReviserData].map((element) => {
      return {
        vrVeze: "1",
        idOsobe: String(element.idOsobe),
      };
    });

    //članovi
    // član 1
    const auditCompanyMember = [...stateCopy.auditCompanyMember].map(
      (element) => {
        return {
          vrClana: "1",
          oib: element.oib,
          ime: element.ime,
          prezime: element.prezime,
          naziv: element.naziv,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
        };
      }
    );
    //član 2
    const auditCompanyBoardMember = [...stateCopy.auditCompanyBoardMember].map(
      (element) => {
        return {
          vrClana: "2",
          oib: element.oib,
          ime: element.ime,
          funkcija: element.funkcija,
          prezime: element.prezime,
          naziv: element.naziv,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          brRegOrig: element.brRegOrig,
        };
      }
    );

    // društvo mreža

    let mrezaInfo = { ...this.state.networkMemberInfo };

    if (mrezaInfo.isDrustvoMreza === false) {
      this.props.formSubmitError(true, "Odaberite članstvo u mreži !");
      return;
    }

    if (mrezaInfo.isDrustvoMreza == 0 || mrezaInfo.isDrustvoMreza === false) {
      delete mrezaInfo.idMreze;
      mrezaInfo.isDrustvoMreza = false;
    } else {
      mrezaInfo.isDrustvoMreza = true;
    }

    const checkMreza = mrezaInfo.hasOwnProperty("idMreze");
    if (checkMreza && !mrezaInfo.idMreze) {
      this.props.formSubmitError(true, "Odaberite mrežu !");
      return;
    }

    // članovi mreže
    const memberInfo = [...stateCopy.memberInfo].map((element) => {
      if (element.vrClana == 1) {
        return {
          idMreze: element.idMreze,
          vrClana: element.vrClana,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          web: element.web,
        };
      }
      return {
        // idDrustva: element.idDrustva,
        vrClana: element.vrClana,
        nazDrustva: element.nazDrustva,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
        web: element.web,
      };
    });

    //oznaka dokumenta => hardkodirano => vidjeti s bekendom sto dalje

    const { oznDokumenta } = this.state.newFormData;

    const registrationArray = [];

    registrationArray.push(regAddress, ...auditCompanyRegistration);

    const membersArray = [];

    membersArray.push(...auditCompanyMember, ...auditCompanyBoardMember);

    const submitData = [
      7,
      userData,
      address,
      registrationArray,
      contactInformation,
      basicReviserData,
      membersArray,
      mrezaInfo,
      memberInfo,
      oznDokumenta,
    ];
    if (this.state.update) {
      submitData.push(stateCopy.mjere);
    }
    if (!this.state.update) {
      submitData.push([]);
    }

    this.props.submitRegistarSubjekata(submitData);
  };

  render() {
    const otherProps = {
      parentState: this.state,
      handleDayClick: this.handleDayClick,
      userInputHandler: this.userInputHandler,
      mappedUserInputHandler: this.mappedUserInputHandler,
      setCountryAutocompleteHandler: this.setCountryAutocompleteHandler,
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCountyHandler: this.autocompleteCountyHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      dropdownHandler: this.dropdownHandler,
      submitHandler: this.submitHandler,
      multiplyComponent: this.multiplyComponent,
      networkDropdownHandler: this.networkDropdownHandler,
      setSelectedNetworkDropdown: this.setSelectedNetworkDropdown,
      createNewNetworkModal: this.createNewNetworkModal,
      createNewNetworkSubmitHandler: this.createNewNetworkSubmitHandler,
      vrClanaDropdownHandler: this.vrClanaDropdownHandler,
      setSelectedNetworkToArray: this.setSelectedNetworkToArray,
      getUserData: this.getUserData,
      getReviserDataByOib: this.getReviserDataByOib,
      revisorDropdownHandler: this.revisorDropdownHandler,
      removeComponentHandler: this.removeComponentHandler,
      openNetworkUpdateModal: this.openNetworkUpdateModal,
      hideUpdateModal: this.hideUpdateModal,
      updateNetworkHandler: this.updateNetworkHandler,
      funkcijaDropDownHandler: this.funkcijaDropDownHandler,
    };
    return (
      <>
        {this.state.requestsLoaded ? (
          <EntryForm7 {...otherProps} />
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idDrustva: state.update.idDrustva,
    vrDrustva: state.update.vrDrustva,
    oznDokumenta: state.update.oznDokumenta,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    purgeUpdate: () => dispatch({ type: PURGE_UPDATE }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RegSubjZaObavljanjeRevUTrecojZemlji));
